import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class Overflow extends AStringEnum
{
    public static AUTO = new AString('Auto');
    public static HIDDEN = new AString('Hidden');
    public static VISIBLE = new AString('Visible');

    private static _types:Array<AString> = [
        Overflow.AUTO,
        Overflow.HIDDEN,
        Overflow.VISIBLE
    ];

    public constructor(value:AString)
    {
        super(value, Overflow._types);
    }

    public static cssValue(overflow:Overflow):'auto' | 'hidden' | 'visible'
    {
        if( Overflow.auto().isEqualTo(overflow) ) return 'auto';
        if( Overflow.hidden().isEqualTo(overflow) ) return 'hidden';
        if( Overflow.visible().isEqualTo(overflow) ) return 'visible';
    }

    public static auto():Overflow
    {
        return new Overflow(Overflow.AUTO);
    }

    public static hidden():Overflow
    {
        return new Overflow(Overflow.HIDDEN);
    }

    public static visible():Overflow
    {
        return new Overflow(Overflow.VISIBLE);
    }
}
